import { render, staticRenderFns } from "./subMenu.vue?vue&type=template&id=53cb775c&scoped=true&functional=true&"
import script from "./subMenu.vue?vue&type=script&lang=js&"
export * from "./subMenu.vue?vue&type=script&lang=js&"
import style0 from "./subMenu.vue?vue&type=style&index=0&id=53cb775c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "53cb775c",
  null
  
)

export default component.exports